import React, { lazy } from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-8 px-4" data-id="element-66">
      <div className="max-w-xl mx-auto flex flex-col items-center text-center" data-id="element-67">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-black mb-4 leading-tight" data-id="element-68">
          Todo tu año de Instalaciones Eléctricas.
          <br data-id="element-69" />
          <span className="text-brand-accent" data-id="element-70">Listo. Desde hoy.</span>
        </h1>

        <h2 className="text-sm md:text-base font-medium mb-6 text-gray-300" data-id="element-71">
          El sistema N°1 para instructores de electrotecnia y maestros de taller
          técnico.
        </h2>

        <div className="w-full max-w-sm mx-auto mb-6 cursor-pointer" onClick={scrollToCompra} data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/owXfzvjWzXej9mESMaD6x8/mockupps_instaliciones_electricas_.png" alt="Kit Completo Instalaciones Eléctricas Listas" className="w-full h-auto" loading="lazy" data-id="element-73" />
        </div>

        <p className="text-sm md:text-base mb-4 font-bold text-white" data-id="element-74">
          Recursos de Instrucción Eléctrica Profesional Planificaciones +
          Evaluaciones + Actividades + Proyectos de Obra. Listos para usar. Sin
          buscar. Sin armar. Sin perder tus domingos.
        </p>

        <div className="flex flex-col gap-2 mb-6 w-full text-xs md:text-sm font-medium text-gray-400" data-id="element-75">
          <p data-id="element-76">
            📄 100% Digital (PDF) | ⚡ Acceso en 5 min | 🔌 Basado en Normativa
            Internacional IEC
          </p>
        </div>

        <div className="w-full mb-4" data-id="element-77">
          <Button className="text-lg py-4" data-id="element-78">👉 QUIERO MI KIT AHORA</Button>
        </div>

        <div className="text-xs text-gray-500" data-id="element-79">
          <p data-id="element-80">Garantía 7 días | Pago seguro | Tarjeta, PayPal o moneda local</p>
        </div>
      </div>
    </section>;
}